import { FrameWithStickyTitle } from 'components/BrandSlides/BrandSlides.jsx';
import { ensureArray, safeMap, ensureString } from 'utils/safeArray';

export default function TableSlide({ title, subtitle, table_json, callout, accent_color }) {
  const tableData = table_json && typeof table_json === 'object' ? table_json : {};
  const headers = ensureArray(tableData.headers);
  const rows = ensureArray(tableData.rows);
  const gridCols = headers.length > 0 ? `grid-cols-${headers.length}` : 'grid-cols-1';

  return (
    <FrameWithStickyTitle title={title} subtitle={subtitle} accentColor={accent_color}>
      <div className="flex flex-col justify-center h-full p-4 md:p-12">
        <div className="w-full text-left overflow-x-auto">
          {/* Grid Header */}
          <div className={`grid ${gridCols} gap-x-4 md:gap-x-8 min-w-max md:min-w-0`}>
            {safeMap(headers, (header, i) => (
              <div key={i} className="border-b-2 border-slate-300 p-2 md:p-4 text-sm md:text-lg font-medium text-slate-500 uppercase tracking-wider">
                {ensureString(header)}
              </div>
            ))}
          </div>

          {/* Grid Body */}
          <div className="mt-2">
            {safeMap(rows, (row, i) => {
              const rowCells = ensureArray(row);
              return (
                <div key={i} className={`grid ${gridCols} gap-x-4 md:gap-x-8 border-b border-slate-200 min-w-max md:min-w-0`}>
                  {safeMap(rowCells, (cell, j) => (
                    <div key={j} className="p-2 md:p-4 text-sm md:text-xl text-slate-700 align-top">
                      {ensureString(cell)}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
        {callout && (
          <div className="mt-4 md:mt-8 text-center">
            <p className="text-sm md:text-lg text-slate-500 italic">{ensureString(callout)}</p>
          </div>
        )}
      </div>
    </FrameWithStickyTitle>
  );
}
